import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/OrderBilling.requests'
import simpleApi from 'app/services/simpleApi'

const useSendToAbacus = ({
    onSuccess,
    onError,
}: {
    onSuccess: () => void,
    onError: () => void,
}) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRequest,
        onError: onErrorRequest,
    } = useHandleStatusRequest({
        id: 'SendToAbacus',
        title: 'Send To Abacus',
        onSuccess,
        onError,
    })

    return useMutation({
        mutationFn: ({
            selectedInvoiceId,
        }: {
            selectedInvoiceId: number,
        }) => {
            return simpleApi({
                ...requests.updateInvoiceStatus({
                    outgoingInvoiceId: selectedInvoiceId,
                    data: {
                        invoiceStatus: 'SENTTOSAP',
                    },
                }),
                token,
            })
        },
        onSuccess: onSuccessRequest,
        onError: onErrorRequest,
    })
}

export default useSendToAbacus
